import React, { FC, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Titled } from 'react-titled';
import SignUpForm from 'components/SignUp/SignUpForm';
import { useTranslation } from 'react-i18next';
import AppLayout from 'components/common/AppLayout';
import { UserTypeEnum } from 'types/enums/User';
import { AppNamesEnum } from 'types/enums/AppNames';
import NoticeLayoutRedesign from 'components/common/NoticeLayoutRedesign';

const deserializeInviteToken = inviteToken => {
  const [inviteId = '', email = '', company = ''] = window
    .atob(inviteToken)
    .split('|');
  return {
    inviteId,
    email,
    company,
  };
};

const SignUp: FC = (): JSX.Element => {
  const location = useLocation();
  const [userType, setUserType] = useState<UserTypeEnum>();
  const inviteToken = new URLSearchParams(location.search).get('invite');
  const phoneNumber = (() => {
    const raw = new URLSearchParams(location.search).get('phoneNumber') || '';
    // URLSearchParams decodes + as a space; restore the leading + so the value
    // is a valid E.164 international number (e.g. " 380..." → "+380...")
    const restored = raw.startsWith(' ') ? `+${raw.trimStart()}` : raw;
    // Strip leading zeros after + — trunk prefixes (e.g. +0145...) are never
    // valid in E.164 and cause incorrect country detection/display.
    return restored.replace(/^\+0+/, '+');
  })();
  const [inviteInfo, setInviteInfo] = useState<any>();
  const [signUpApp, setSignUpApp] = useState<AppNamesEnum>();
  const [signUpPartnerGuest, setSignUpPartnerGuest] = useState<AppNamesEnum>();
  const isInAppWebview =
    new URLSearchParams(location.search).get('isInAppWebview') === 'true';

  useEffect(() => {
    setUserType(
      (new URLSearchParams(location.search)
        .get('userType')
        ?.toUpperCase() as UserTypeEnum) ?? UserTypeEnum.PARTNER
    );
    if (inviteToken) {
      setInviteInfo(deserializeInviteToken(inviteToken));
    }
    if (new URLSearchParams(location.search).get('signUpPartnerGuest')) {
      setSignUpPartnerGuest(
        new URLSearchParams(location.search)
          .get('signUpPartnerGuest')
          ?.toUpperCase() as AppNamesEnum
      );
    }

    if (new URLSearchParams(location.search).get('signUpApp')) {
      setSignUpApp(
        new URLSearchParams(location.search)
          .get('signUpApp')
          ?.toUpperCase() as AppNamesEnum
      );
    }
  }, []);

  const { t } = useTranslation();
  // If invited, make sure invite token is deserialized first
  const showSignupForm = !inviteToken || inviteInfo;
  return (
    <Titled title={title => `${t('user.signUp.header')} - ${title}`}>
      <AppLayout
        showHeader={false}
        showLeftNav={false}
        showGreyPanel={true}
        showFooter={false}>
        <NoticeLayoutRedesign
          title={t('user.signUp.header')}
          mobileFooterPadding={true}>
          {showSignupForm && (
            <SignUpForm
              {...{
                firstName: '',
                lastName: '',
                email: inviteInfo?.email,
                phoneNumber: phoneNumber || '',
                country: '',
                userType,
                inviteToken,
                signUpApp,
                signUpPartnerGuest,
                isInAppWebview,
              }}
            />
          )}
        </NoticeLayoutRedesign>
      </AppLayout>
    </Titled>
  );
};

export default SignUp;
